var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-panel-base',{staticClass:"code-string",attrs:{"color":_vm.color,"align":_vm.align,"tag":_vm.tag,"justify":"start","gap":"3"}},[_c('ui-icon',{attrs:{"icon":_vm.icon,"type":_vm.iconType}}),_vm._v(" "),_c('code',{staticClass:"code-string__label"},[_vm._v(" \""+_vm._s(_vm.label)+"\" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }